import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectStatusFilter = createSelector(
  [(store: RootState) => store.documentsList.statusFilter],
  (value) => value
);
